export const STORAGE_ENFORCEMENT_STATE_KEYS = {
	FLAGS_DISMISSED_FREE_THRESHOLD: 'storage-enforcement-state:flagsDismissedFreeThreshold',
} as const;

export const StorageEnforcementOnboardingKeys: readonly 'storage-enforcement-state:flagsDismissedFreeThreshold'[] =
	Object.values(STORAGE_ENFORCEMENT_STATE_KEYS);
